enum TemplateEvents {
  TemplateOpened = 'TemplateOpened',
  TemplateCreated = 'TemplateCreated',
  TemplateUpdated = 'TemplateUpdated',
  TemplateUpdateConflict = 'TemplateUpdateConflict',
  TemplateDeleted = 'TemplateDeleted'
};

export default TemplateEvents;
